<app-profile-confirm-modal [toDo]="'confirm'" *ngIf="confirmModal"></app-profile-confirm-modal>
<form 
  name="createPasswordForm" 
  [formGroup]="createPasswordForm" 
  (ngSubmit)="createPasswordForm.valid && createNewPassword()" class="create-password-form">
  <div class="row no-margin">
    <div class="col no-padding">
      <div *ngFor="let input of inputs" class="inputs mt-20">
        <ng-container *ngIf="createUserInfo?.userDetails?.lastName !== ''; else createUserPswd">
          <mapfre-validation [input]="input" [form]="createPasswordForm" [firstName]="createUserInfo?.userDetails?.firstName" [lastName]="createUserInfo?.userDetails?.lastName" [errorMsg]="errorMessage" (passwordValidationCheck)="isPasswordValid($event)"></mapfre-validation>
        </ng-container>
        <ng-template #createUserPswd>
          <mapfre-validation [input]="input" [form]="createPasswordForm" [firstName]="createUserInfo?.userDetails?.firstName" [errorMsg]="errorMessage" (passwordValidationCheck)="isPasswordValid($event)"></mapfre-validation>
        </ng-template>
      </div>
    </div>
  </div>
  <div *ngIf="whereInTheProcess==='edit-password'; else setNewPassword">
      <section class="row text-center no-margin">
          <div class="col no-padding" [ngClass]="{'margin-top mt24': !isAcmic}">
            <mapfre-button [ngClass]="{'custom_loader':loader}"
              [additionalClasses]="'basic primary large-btn w-100-percent'"
              [disabledValue]="createPasswordForm.valid && enableBtn && !loader" 
              [inputType]="'submit'"
              [translateValue]="'SET_PASSWORD' | translate"
            ></mapfre-button>
          </div>
        </section>
  </div>
  <ng-template #setNewPassword>
      <section class="row text-center">
          <div class="col no-padding">
            <mapfre-button [ngClass]="{'custom_loader':loader}"
              [additionalClasses]="'basic primary large-btn w-100-percent'"
              [disabledValue]="createPasswordForm.valid && enableBtn && !loader" 
              [inputType]="'submit'"
              [translateValue]="'SET_PASSWORD' | translate"
            ></mapfre-button>
          </div>
        </section>
  </ng-template>
</form>
<div class="row margin-top mt24 text-center" *ngIf="whereInTheProcess==='edit-password'">
  <div class="col no-padding">
    <mapfre-button
      (click)="onCheckDirty()"
      additionalClasses="link-button small red-link no-margin button-border-red create-password-back"
      [backIcon]="'./assets/img/images/change-password-icon-left.svg'"
      [iconClasses]="'align-middle pr-1'"
      [showIconsCustom]="true"
    >  {{ 'BACK' | translate }}
    </mapfre-button>
  </div>
</div>